import type { ResourceType } from './types';

export const resourceTypes: ResourceType[] = [
  'Link',
  'PDF',
  'Image',
];

export const typeStyles: Record<ResourceType, { badge: string; icon: string }> =
  {
    Link: {
      badge: 'bg-blue-100 text-blue-600',
      icon: 'bg-blue-50 text-blue-500',
    },
    PDF: {
      badge: 'bg-rose-100 text-rose-600',
      icon: 'bg-rose-50 text-rose-500',
    },
    Image: {
      badge: 'bg-amber-100 text-amber-600',
      icon: 'bg-amber-50 text-amber-500',
    },
  };

export const uploadConfig: Record<
  Exclude<ResourceType, 'Link'>,
  { label: string; hint: string; accept: string }
> = {
  PDF: {
    label: 'Upload PDF or drag and drop',
    hint: 'Only .pdf files',
    accept: '.pdf',
  },
  Image: {
    label: 'Upload image or drag and drop',
    hint: 'Only .png, .jpg, .jpeg files',
    accept: 'image/*',
  },
};
